module.exports = __webpack_public_path__ + "img/banner_talent_exchange.fdef0282.png";